<template>
  <div class="public-alert">
    <MnemonicWordsDialog />
  </div>
</template>

<script>
import MnemonicWordsDialog from './MnemonicWordsDialog.vue'
export default {
  name: 'PublicAlert',
  data () {
    return {
    }
  },
  methods: {
  },
  components: {
    MnemonicWordsDialog
  }
}
</script>
